class CroMenuDrilldown extends HTMLElement {
  connectedCallback() {
    this.root = this.querySelector('[data-drill-panel="root"]');
    if (!this.root) return;
    this.opener = null;

    this.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-drill-open]');
      if (opener && this.contains(opener)) {
        event.preventDefault();
        this.open(opener);
        return;
      }
      if (event.target.closest('[data-drill-back]')) {
        event.preventDefault();
        this.close(true);
      }
    });

    this.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.opener) {
        event.stopPropagation();
        this.close(true);
      }
    });

    const item = this.closest('.menu-list__list-item');
    if (item) {
      item.addEventListener('pointerleave', () => this.close(false));
      item.addEventListener('focusout', (event) => {
        if (!item.contains(event.relatedTarget)) this.close(false);
      });
    }
  }

  open(opener) {
    const panel = this.querySelector(`#${CSS.escape(opener.getAttribute('data-drill-open'))}`);
    if (!panel || this.opener === opener) return;

    panel.classList.remove('translate-x-full', 'opacity-0');
    panel.removeAttribute('inert');
    opener.setAttribute('aria-expanded', 'true');
    panel.querySelector('[data-drill-back]')?.focus({ preventScroll: true });

    this.root.classList.add('-translate-x-full', 'opacity-0');
    this.root.setAttribute('inert', '');
    this.opener = opener;
  }

  close(restoreFocus) {
    if (!this.opener) return;
    const opener = this.opener;
    const panel = this.querySelector(`#${CSS.escape(opener.getAttribute('data-drill-open'))}`);
    this.opener = null;

    this.root.classList.remove('-translate-x-full', 'opacity-0');
    this.root.removeAttribute('inert');
    opener.setAttribute('aria-expanded', 'false');
    if (restoreFocus) opener.focus({ preventScroll: true });

    if (panel) {
      panel.classList.add('translate-x-full', 'opacity-0');
      panel.setAttribute('inert', '');
    }
  }
}

if (!customElements.get('cro-menu-drilldown')) {
  customElements.define('cro-menu-drilldown', CroMenuDrilldown);
}
